import { EpgByDaysQueryInfo } from '@shared/types/interfaces/query';

/******************/
/**     INFO     **/
/******************/

/**
 * @param channelId Channel identifier to fetch
 * @returns {EpgByDaysQueryInfo} Epg by days query info
 */
export default function info(channelId: string): EpgByDaysQueryInfo {
  const date = new Date();
  date.setHours(date.getHours(), 0, 0, 0);
  const beginTime = date.toISOString();
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return {
    query: {
      beginTime,
      channelId,
      timeZone,
    },
  };
}
